module.exports = __webpack_public_path__ + "img/yonhi-lescano.576d58f2.png";